import { utilityServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = utilityServicesPath + '/admin/vacancies'

export default class AdminVacanciesService {

    static async get() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async add(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, id) {
        return await axios.put(`${restUrl}/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${restUrl}/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}